/** Máscaras do formulário de cadastro, como a pessoa digita; o que vai à API é o valor limpo. */

export function onlyDigits(text: string) {
  return text.replace(/\D/g, '')
}

/** "11999990000" → "(11) 99999-0000", aceitando a digitação parcial. */
export function maskPhone(text: string) {
  const d = onlyDigits(text).slice(0, 11)
  if (d.length <= 2) return d.length ? `(${d}` : ''
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
}

/** "15021993" → "15/02/1993", aceitando a digitação parcial. */
export function maskDate(text: string) {
  const d = onlyDigits(text).slice(0, 8)
  if (d.length <= 2) return d
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`
}

/** "dd/mm/aaaa" → "aaaa-mm-dd"; `null` quando a data não existe. */
export function brDateToIso(text: string): string | null {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(text.trim())
  if (!match) return null
  const [, dd, mm, yyyy] = match
  const date = new Date(Date.UTC(Number(yyyy), Number(mm) - 1, Number(dd)))
  const exists =
    date.getUTCFullYear() === Number(yyyy) &&
    date.getUTCMonth() === Number(mm) - 1 &&
    date.getUTCDate() === Number(dd)
  return exists ? `${yyyy}-${mm}-${dd}` : null
}

/** "12345678909" → "123.456.789-09", aceitando a digitação parcial. */
export function maskCpf(text: string) {
  const d = onlyDigits(text).slice(0, 11)
  if (d.length <= 3) return d
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`
}

/** Dígito verificador do CPF; o mesmo cálculo da API. */
export function isValidCpf(text: string): boolean {
  const d = onlyDigits(text)
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false
  const digit = (slice: string, weight: number) => {
    let sum = 0
    for (const char of slice) sum += Number(char) * weight--
    const rest = (sum * 10) % 11
    return rest === 10 ? 0 : rest
  }
  return digit(d.slice(0, 9), 10) === Number(d[9]) && digit(d.slice(0, 10), 11) === Number(d[10])
}

export function isEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}

/** "09015000" → "09015-000", aceitando a digitação parcial. */
export function maskPostalCode(text: string) {
  const d = onlyDigits(text).slice(0, 8)
  return d.length <= 5 ? d : `${d.slice(0, 5)}-${d.slice(5)}`
}

/** O nome de usuário do Instagram, sem o @ e sem espaços. */
export function maskInstagram(text: string) {
  return text.replace(/^@+/, '').replace(/\s/g, '').slice(0, 30)
}

/**
 * WhatsApp com o DDI escolhido: no Brasil, DDD e número com máscara; de outro país, só os dígitos,
 * até onde o número inteiro (DDI e número) cabe nos 15 dígitos do E.164.
 */
export function maskWhatsapp(text: string, dialCode: string) {
  if (dialCode === '+55') return maskPhone(text)
  return onlyDigits(text).slice(0, 15 - onlyDigits(dialCode).length)
}
